<div>
  <!-- Error Message -->
  <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header Actions -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-people me-2"></i>
      Members
      <span class="badge bg-secondary ms-2">{{ activeMembers.length + inactiveMembers.length }}</span>
    </h5>
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-primary" (click)="openInviteMemberModal()">
        <i class="bi bi-person-plus me-2"></i>
        Invite Member
      </button>
      <div class="btn-group">
        <button type="button" class="btn btn-outline-primary" (click)="openAssignOwnerModal()">
          <i class="bi bi-star me-2"></i>
          Transfer Ownership
        </button>
        <button type="button" class="btn btn-outline-success" (click)="openAssignCSModal()">
          <i class="bi bi-shield me-2"></i>
          Assign Chief Supervisor
        </button>
      </div>
    </div>
  </div>

  <!-- Active Members Section -->
  <div class="mb-4" *ngIf="activeMembers.length > 0">
    <h6 class="text-muted mb-3">
      <i class="bi bi-people-fill me-2"></i>
      Active Members
      <span class="badge bg-success ms-2">{{ activeMembers.length }}</span>
    </h6>

    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Member</th>
            <th>Roles</th>
            <th>Joined</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let member of activeMembers" class="cursor-pointer" (click)="viewMember(member.profileId)">
            <td>
              <div class="d-flex align-items-center">
                <div class="entity-avatar me-3">
                  {{ member.firstName?.charAt(0) || '' }}{{ member.lastName?.charAt(0) || '' }}
                </div>
                <div>
                  <div class="fw-bold">
                    {{ member.firstName }} {{ member.lastName }}
                    <span class="badge bg-warning text-dark ms-2" *ngIf="member.hasAcceptedInvite === false" title="This member has not yet accepted their invitation and created an account">
                      <i class="bi bi-hourglass-split me-1"></i>Pending Signup
                    </span>
                  </div>
                  <small class="text-muted">{{ member.email }}</small>
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex flex-wrap gap-1">
                <span class="badge bg-warning text-dark" *ngIf="member.isOwner">
                  <i class="bi bi-star-fill me-1"></i>
                  Owner
                </span>
                <span class="badge bg-success" *ngIf="member.isChiefSupervisor">
                  <i class="bi bi-shield-fill me-1"></i>
                  Chief Supervisor
                </span>
                <span
                  *ngFor="let roleName of getMembershipRoleNames(member.role)"
                  class="badge"
                  [ngClass]="{
                    'bg-primary': roleName === 'Pilot in Command',
                    'bg-secondary': roleName === 'Pilot'
                  }"
                >
                  {{ roleName }}
                </span>
              </div>
            </td>
            <td>
              <small>{{ formatDate(member.createdAt) }}</small>
            </td>
            <td>
              <div class="btn-group btn-group-sm">
                <button
                  *ngIf="member.hasAcceptedInvite === false && !hasPendingInvitation(member.email)"
                  type="button"
                  class="btn btn-outline-success"
                  (click)="sendInviteForMember(member); $event.stopPropagation()"
                  [disabled]="processing"
                  title="Send invitation email"
                >
                  <i class="bi bi-envelope"></i>
                  Send Invite
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="openEditRoleModal(member); $event.stopPropagation()"
                  [disabled]="member.hasAcceptedInvite === false"
                  [title]="member.hasAcceptedInvite === false ? 'User must accept invitation before editing roles' : 'Edit roles (Pilot/PIC)'"
                >
                  <i class="bi bi-pencil"></i>
                  Edit Role
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger"
                  (click)="removeMember(member); $event.stopPropagation()"
                  [disabled]="processing || member.isOwner"
                  title="Remove from organization"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pending Invitations Section -->
  <div class="mb-4" *ngIf="pendingInvitations.length > 0 || pendingMembers.length > 0">
    <h6 class="text-muted mb-3">
      <i class="bi bi-envelope me-2"></i>
      Pending Invitations
      <span class="badge bg-warning ms-2">{{ pendingInvitations.length + pendingMembers.length }}</span>
    </h6>

    <div class="table-responsive">
      <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Email Status</th>
              <th>Expires</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let invitation of pendingInvitations">
              <td>
                <i class="bi bi-envelope-fill me-2 text-warning"></i>
                {{ invitation.email }}
              </td>
              <td>{{ invitation.firstName }} {{ invitation.lastName }}</td>
              <td>
                <div class="d-flex flex-wrap gap-1">
                  <span
                    *ngFor="let roleName of getMembershipRoleNames(invitation.role)"
                    class="badge"
                    [ngClass]="{
                      'bg-primary': roleName === 'Pilot in Command',
                      'bg-secondary': roleName === 'Pilot'
                    }"
                  >
                    {{ roleName }}
                  </span>
                </div>
              </td>
              <td>
                <span class="badge" [ngClass]="getEmailStatusClass(invitation.emailStatus)">
                  {{ getEmailStatusText(invitation.emailStatus) }}
                </span>
                <small *ngIf="invitation.emailSentAt" class="d-block text-muted mt-1">
                  {{ formatDate(invitation.emailSentAt) }}
                </small>
                <small *ngIf="invitation.emailStatus === 'failed' && invitation.emailError" class="d-block text-danger mt-1">
                  {{ invitation.emailError }}
                </small>
              </td>
              <td>
                <small [class.text-danger]="isExpiringSoon(invitation.expiresAt)">
                  {{ formatDate(invitation.expiresAt) }}
                </small>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <!-- Send Email button: only show if email has never been sent -->
                  <button
                    *ngIf="invitation.emailStatus === 'never_sent' || invitation.emailStatus === 'failed'"
                    type="button"
                    class="btn btn-primary"
                    (click)="sendInvitationEmail(invitation)"
                    [disabled]="processing"
                    title="Send invitation email"
                  >
                    <i class="bi bi-envelope"></i>
                    Send Email
                  </button>
                  <!-- Resend button: only show if email was already sent -->
                  <button
                    *ngIf="invitation.emailStatus === 'sent'"
                    type="button"
                    class="btn btn-outline-primary"
                    (click)="resendInvitation(invitation)"
                    [disabled]="processing"
                    title="Resend invitation email"
                  >
                    <i class="bi bi-send"></i>
                    Resend
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    (click)="cancelInvitation(invitation)"
                    [disabled]="processing"
                    title="Cancel invitation"
                  >
                    <i class="bi bi-x-circle"></i>
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
            @for (member of pendingMembers; track member.email) {
              <tr (click)="viewMember(member.profileId)">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="entity-avatar me-3">
                      {{ member.firstName?.charAt(0) || '' }}{{ member.lastName?.charAt(0) || '' }}
                    </div>
                    <div>
                      <div class="fw-bold">
                        {{ member.firstName }} {{ member.lastName }}
                        <span class="badge bg-warning text-dark ms-2" *ngIf="member.hasAcceptedInvite === false" title="This member has not yet accepted their invitation and created an account">
                          <i class="bi bi-hourglass-split me-1"></i>Pending Signup
                        </span>
                      </div>
                      <small class="text-muted">{{ member.email }}</small>
                    </div>
                  </div>
                </td>
                <td></td>
                <td>
                  <div class="d-flex flex-wrap gap-1">
                    <span class="badge bg-warning text-dark" *ngIf="member.isOwner">
                      <i class="bi bi-star-fill me-1"></i>
                      Owner
                    </span>
                    <span class="badge bg-success" *ngIf="member.isChiefSupervisor">
                      <i class="bi bi-shield-fill me-1"></i>
                      Chief Supervisor
                    </span>
                    <span
                      *ngFor="let roleName of getMembershipRoleNames(member.role)"
                      class="badge"
                      [ngClass]="{
                        'bg-primary': roleName === 'Pilot in Command',
                        'bg-secondary': roleName === 'Pilot'
                      }"
                    >
                      {{ roleName }}
                    </span>
                  </div>
                </td>
                <td>
                  @if (getPendingInvitation(member.email); as inv) {
                    <span class="badge" [ngClass]="getEmailStatusClass(inv.emailStatus)">
                      {{ getEmailStatusText(inv.emailStatus) }}
                    </span>
                    @if (inv.emailSentAt) {
                      <small class="d-block text-muted mt-1">
                        {{ formatDate(inv.emailSentAt) }}
                      </small>
                    }
                    @if (inv.emailStatus === 'failed' && inv.emailError) {
                      <small class="d-block text-danger mt-1">
                        {{ inv.emailError }}
                      </small>
                    }
                  } @else {
                    <span class="badge" [ngClass]="getEmailStatusClass('never_sent')">
                      {{ getEmailStatusText('never_sent') }}
                    </span>
                  }
                </td>
                <td></td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button
                      *ngIf="member.hasAcceptedInvite === false && !hasPendingInvitation(member.email)"
                      type="button"
                      class="btn btn-outline-success"
                      (click)="sendInviteForMember(member); $event.stopPropagation()"
                      [disabled]="processing"
                      title="Send invitation email"
                    >
                      <i class="bi bi-envelope"></i>
                      Send Invite
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      (click)="openEditRoleModal(member); $event.stopPropagation()"
                      [disabled]="member.hasAcceptedInvite === false"
                      [title]="member.hasAcceptedInvite === false ? 'User must accept invitation before editing roles' : 'Edit roles (Pilot/PIC)'"
                    >
                      <i class="bi bi-pencil"></i>
                      Edit Role
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      (click)="removeMember(member); $event.stopPropagation()"
                      [disabled]="processing || member.isOwner"
                      title="Remove from organization"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
    </div>
  </div>

  <!-- Inactive Members Section -->
  <div class="mb-4" *ngIf="inactiveMembers.length > 0">
    <h6 class="text-muted mb-3">
      <i class="bi bi-person-x me-2"></i>
      Inactive Members
      <span class="badge bg-secondary ms-2">{{ inactiveMembers.length }}</span>
    </h6>

    <div>
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Member</th>
            <th>Previous Roles</th>
            <th>Removed</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let member of inactiveMembers" class="text-muted cursor-pointer" (click)="viewMember(member.profileId)">
            <td>
              <div class="d-flex align-items-center">
                <div class="entity-avatar me-3 opacity-50">
                  {{ member.firstName?.charAt(0) || '' }}{{ member.lastName?.charAt(0) || '' }}
                </div>
                <div>
                  <div>{{ member.firstName }} {{ member.lastName }}</div>
                  <small>{{ member.email }}</small>
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex flex-wrap gap-1">
                <span
                  *ngFor="let roleName of getMembershipRoleNames(member.role)"
                  class="badge bg-secondary opacity-75"
                >
                  {{ roleName }}
                </span>
              </div>
            </td>
            <td>
              <small>{{ formatDate(member.deletedAt || '') }}</small>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-outline-success btn-sm"
                (click)="reactivateMember(member); $event.stopPropagation()"
                [disabled]="processing"
              >
                <i class="bi bi-arrow-clockwise me-1"></i>
                Reactivate
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Members -->
  <div class="text-center py-5 text-muted" *ngIf="activeMembers.length === 0 && inactiveMembers.length === 0">
    <i class="bi bi-people fs-1 d-block mb-3"></i>
    <p>No members found</p>
  </div>
</div>

<!-- Modals -->
<app-edit-member-role-modal
  *ngIf="showEditRoleModal && selectedMember"
  [organizationId]="organizationId"
  [member]="selectedMember"
  (close)="closeEditRoleModal()"
  (roleUpdated)="onRoleUpdated()"
></app-edit-member-role-modal>

<app-assign-owner-modal
  *ngIf="showAssignOwnerModal"
  [organizationId]="organizationId"
  [members]="members"
  [currentOwnerId]="ownerProfileId"
  (close)="closeAssignOwnerModal()"
  (ownershipTransferred)="onOwnershipTransferred()"
></app-assign-owner-modal>

<app-assign-chief-supervisor-modal
  *ngIf="showAssignCSModal"
  [organizationId]="organizationId"
  [members]="members"
  [currentChiefSupervisorId]="chiefSupervisorProfileId"
  (close)="closeAssignCSModal()"
  (chiefSupervisorAssigned)="onChiefSupervisorAssigned()"
></app-assign-chief-supervisor-modal>

<app-admin-invite-member-modal
  *ngIf="showInviteMemberModal"
  [organizationId]="organizationId"
  [organizationName]="organizationName"
  (closed)="closeInviteMemberModal()"
  (invited)="onMemberInvited()"
></app-admin-invite-member-modal>
